// extracted by mini-css-extract-plugin
export default {"container":"TextareaCustom_container__KPugE"};